<template>
    <div class="app">
        <form class="login-form" action="" v-on:submit="submitVerifyCode">
            <div class="big-tips">
                发送短信验证码至电子健康卡手机号:
                <br/>
                <label class="f-strongest">{{mobileNo | dotted}}</label>
            </div>
            <verify-code v-model="verifyCode" namespace="residentHealthRecordCode" url="/app/user/send" :param="sendCodeParam" @send-finish="sendFinish"></verify-code>
            <div style="padding: 0.75rem 0.5rem;">
                <button class="btn-ok phone-click-next" type="submit" >下一步</button>
            </div>
        </form>
    </div>
</template>
<script>
    import reportDataService from 'reportData.service'
    import VerifyCode from '../../components/VerifyCode'
    const check = function(form) {
        if (!form.verifyCode) {
            return '请输入验证码'
        }
    };
    export default {
        components: {
            VerifyCode
        },
        data() {
            const pageParams = this.$store.state.paramModule.param.residentHealthRecordCode;
            const voucher = pageParams.selectedVoucher ? JSON.parse(pageParams.selectedVoucher) : {}
            return {
                selectedVoucher: voucher,
                verifyCode: '',
                sendCodeParam: {
                    mobileNo: voucher.mobileNo || '',
                    // 1：注册/登录 2：修改密码 3：修改手机号 4：就诊凭证 5：查询健康档案
                    operateType: '5'
                }
            }
        },
        computed: {
            mobileNo() {
                return this.selectedVoucher.mobileNo || ''
            }
        },
        methods: {
            sendFinish() {
                // 数据上报-健康档案应用授权
                reportDataService.reportData({
                    serviceId: this.constant.SERVICE_ID.HEALTH_RECORD_APPLICATION_AUTHORIZATION,
                    certificateId: this.selectedVoucher.cardNo || '',
                    certificateType: this.selectedVoucher.idType || ''
                })
            },
            submitVerifyCode ($event) {
                $event.preventDefault();
                const msg = check(this);
                if (msg) {
                    return this.$utils.alert(msg);
                }
                // 效验验证码是否正确
                this.$http.post('/app/user/healthRecorderVerify', {
                    mobileNo: this.selectedVoucher.mobileNo || '',
                    verifyCode: this.verifyCode
                }).then(res => {
                    const data = res.body;
                    if (data.resultCode !== this.constant.RESULT_SUCCESS) {
                        this.$utils.alert(data.resultMsg)
                        return
                    }
                    this.goHealthRecorderPage();
                })
            },
            goHealthRecorderPage() {
                // 数据上报-健康档案调阅查询
                reportDataService.reportData({
                    serviceId: this.constant.SERVICE_ID.HEALTH_RECORDS_QUERY,
                    certificateId: this.selectedVoucher.cardNo || '',
                    certificateType: this.selectedVoucher.idType || ''
                })
                // 页面跳转
                const encryptionCardNo = this.selectedVoucher.encryptionCardNo;
                const arr = []
                const src = 'http://pzwjw-imts.hngwmt.com/jkda/BsoftWeChatPZ/index/records?idCardVal='
                arr.push(src)
                arr.push(encryptionCardNo)
                arr.push('#/record_list')
                const str = arr.join('')
                window.location.replace(str)
            }
        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// sendVerifyCode.vue?72c32272